import React from 'react';
import { inicialesDe, PLATAFORMAS, tonoDe } from '../../utils/contactos';

export function AvatarContacto({ contacto, grande = false }) {
  const iniciales = inicialesDe(contacto);
  return (
    <span
      className={`contactos-avatar contactos-avatar--tono-${tonoDe(contacto.chatId)}${grande ? ' contactos-avatar--grande' : ''}`}
      aria-hidden="true"
    >
      {iniciales || (
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
  );
}

export function CanalContacto({ plataforma }) {
  return (
    <span className={`contactos-canal contactos-canal--${plataforma}`}>
      {PLATAFORMAS[plataforma] || plataforma}
    </span>
  );
}
